import { Injectable } from '@angular/core';

import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class apiClientService {
  
  constructor(
    private api: ApiService,
    private util: UtilService
  ) {}

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }
  get orgID(): string | null{
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  createMapping(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      }
    };
    
    return this.api.post(URL.INBOUND_API.DATA_MAPPING, postData );
  }

  getAllMapping() {
    return this.api.get(URL.INBOUND_API.DATA_MAPPING);
  }

  sendRequest(data: any, selectedModule: any) {
    const postData: APIRequest = {
      requestBody: data
    };
    
    return this.api.post(`${URL.INBOUND_API.DATA_INTEGRATION}?module=${selectedModule}`, postData );
  }

  // API Client Request CRUD APIs
  getAllRequests() {
    return this.api.get(`${URL.API_CLIENT}/requests`);
  }

  getRequestById(id: number) {
    return this.api.get(`${URL.API_CLIENT}/requests/${id}`);
  }

  createRequest(data: any) {
    const postData: APIRequest = {
      requestBody: data
    };
    
    return this.api.post(`${URL.API_CLIENT}/requests`, postData);
  }

  updateRequest(id: number, data: any) {
    const putData: APIRequest = {
      requestBody: data
    };
    
    return this.api.put(`${URL.API_CLIENT}/requests/${id}`, putData);
  }

  deleteRequest(id: number) {
    return this.api.delete(`${URL.API_CLIENT}/requests`, String(id));
  }

 updateRequestStatus(id: number, isActive: boolean) {
  const putData: APIRequest = {
    requestBody: { is_active: isActive }
  };

  return this.api.put(`${URL.API_CLIENT}/requests/${id}/status`, putData);
}


// api integration configs
getAllIntegrations() {

  return this.api.get('/api-integration');

}


createIntegration(data: any) {

  const postData: APIRequest = {
    requestBody: data
  };

  return this.api.post('/api-integration', postData);

}

updateIntegration(id: number, data: any) {
  const putData: APIRequest = {
    requestBody: {
      id: id,     
      ...data
    }
  };

  return this.api.post('/api-integration', putData);
}
updateIntegrationStatus(id: number, isActive: boolean) {

  const postData = {
    requestBody: {
      is_active: isActive
    }
  };

  return this.api.post(`/api-integration/status/${id}`, postData);
}
getIntegrationById(id: number) {

  return this.api.get(`/api-integration/${id}`);

}

deleteIntegration(id: number) {

  const payload: APIRequest = {
    requestBody: {
      is_active: false,
      is_deleted: true,
      is_archived: false
    }
  };

  return this.api.post(`/api-integration/updateStatus/${id}`, payload);

}
}